import { armColors, trackerColors } from '../helpers/colorDecoder';

class GCU {
  constructor(gcu) {
    this.info = {
      name: gcu.name,
      id: gcu.code,
      timeFetched: gcu.timeFetched
    };
  }

  sumTrackerStatus(status) {
    const outputData = {
      total: status.length,
      track: 0,
      stow: 0,
      idle: 0,
      sleep: 0,
      error: 0,
      other: 0,
      unknown: 0
    };

    status.forEach((tracker) => {
      if (tracker.status) {
        switch (tracker.status.description) {
          case 'Track':
            outputData.track++;
            break;
          case 'Stow':
            outputData.stow++;
            break;
          case 'Idle':
            outputData.idle++;
            break;
          case 'Sleep':
            outputData.sleep++;
            break;
          case 'Error' || 'RS Err':
            outputData.error++;
            break;
          default:
            outputData.other++;
            break;
        }
      } else {
        outputData.unknown++;
      }
    });

    this.tracker = outputData;
  }

  sumArmStatus(status) {
    const outputData = {
      total: status.length * 4,
      healthy: 0,
      azimuthError: 0,
      elevationError: 0,
      otherError: 0,
      unknownError: 0
    };

    status.forEach((tracker) => {
      if (tracker.armErrors) {
        tracker.armErrors.forEach((error) => {
          switch (error.name) {
            case 'Healthy':
              outputData.healthy++;
              break;
            case 'Azimuth Reed Error':
              outputData.azimuthError++;
              break;
            case 'Elevation Reed Error':
              outputData.elevationError++;
              break;
            default:
              outputData.otherError++;
              break;
          }
        });
      }

      if (tracker.armErrors && tracker.armErrors.length < 4) {
        outputData.unknownError += (4 - tracker.armErrors.length);
      } else if (!tracker.armErrors) {
        outputData.unknownError += 4;
      }
    });

    this.armature = outputData;
  }

  setGCUStatus(gcuStatus = 'PENDING') {
    this.status = gcuStatus;
  }

  setArmColors() {
    this.armColors = armColors;
  }

  setTrackerColors() {
    this.trackerColors = trackerColors;
  }
}

export default GCU;
